import { PageMeta } from '../../../domain/models/organization/page.model';
import { OrgSdk } from 'lib-klab-sdks';

export function mapSdkPaginationToDomainPageMeta(
    p?: OrgSdk.PaginationResponse
): PageMeta {
    return {
        number: p?.number ?? 0,
        size: p?.size ?? 0,
        totalElements: p?.totalElements ?? 0,
        totalPages: p?.totalPages ?? 0,
    };
}
